export const projects = [
  {
    name: 'Tesla Service, Sales and Distribution Center',
    sector: 'Commercial',
    highlights: [
      '150,000 sq ft facility at 30-02 Whitestone Expressway.',
      'Complete HVAC design and installation for service, sales, and distribution operations.',
      'Recently completed project showcasing ANR Mechanical capabilities.',
    ],
  },
  {
    name: 'NYC Courthouse HVAC Upgrade',
    sector: 'Government',
    highlights: [
      'Phased replacement of chillers, pumps, and VAVs in an occupied justice facility.',
      'Coordinated night work to maintain 24/7 courtroom operations.',
      'Upgraded building automation and remote monitoring.',
    ],
  },
  {
    name: 'Mount Sinai Critical Care AHU',
    sector: 'Healthcare',
    highlights: [
      'Custom air handling units serving ICU and procedure rooms.',
      'Pressure monitoring and redundancy for life-safety compliance.',
      'Rigging and installation within tight urban site.',
    ],
  },
  {
    name: 'Brooklyn Tech Campus Central Plant',
    sector: 'Education',
    highlights: [
      'Design-build central plant with cooling towers, boilers, and heat exchangers.',
      'Integration with campus-wide controls platform.',
      'Delivered ahead of semester opening.',
    ],
  },
  {
    name: 'Hudson Yards Data Center Cooling',
    sector: 'Commercial',
    highlights: [
      'Generator cooling, CRAC installations, and hot-aisle containment.',
      'Critical power coordination with electrical trade partners.',
      '24/7 commissioning and trend verification.',
    ],
  },
];
